const initialState = {
  total: -1,
  results: [],
};
const reducerName = 'Storefronts';
const updateAction = (state, action) => {
  const doesExit = state.results.some(x => x.id === action.updatedResult.id);
  let updatedResults = state.results.map(result =>
    result.uid === action.updatedResult.uid ? action.updatedResult : result,
  );
  if (!doesExit) updatedResults = updatedResults.concat(action.updatedResult);

  const updatedTotal = state.total < 0 ? -1 : updatedResults.length;
  return {
    ...state,
    results: updatedResults,
    total: updatedTotal,
  };
};
const storefrontsReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'Get'.concat(reducerName):
      return state;
    case 'Insert'.concat(reducerName):
      return {
        results: state.results.concat(
          action.payload.results.filter(
            incoming =>
              state.results.some(current => current.id === incoming.id) ===
              false,
          ),
        ),
        total: action.payload.total ?? state.total,
      };
    case 'Update'.concat(reducerName):
      return updateAction(state, action);
    case 'Delete'.concat(reducerName):
      return {
        results: state.results.filter(
          storefront => storefront.id !== action.payload.id,
        ),
        total: state.total - 1,
      };
    default:
      return state;
  }
};

export default storefrontsReducer;
